import React, {memo} from "react";

export const IconPencilLine = memo(({color, addClass}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={addClass}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.50027 17C2.36927 17 2.24227 16.949 2.14627 16.854C2.01827 16.726 1.96927 16.538 2.01927 16.363L3.01927 12.863C3.04227 12.781 3.08627 12.707 3.14627 12.647L14.1463 1.64698C14.3413 1.45198 14.6583 1.45198 14.8533 1.64698L17.3533 4.14698C17.5483 4.34198 17.5483 4.65898 17.3533 4.85398L6.35327 15.854C6.29327 15.914 6.21927 15.958 6.13727 15.981L2.63727 16.981C2.59227 16.994 2.54527 17 2.50027 17ZM3.94527 13.262L3.22827 15.772L5.73827 15.055L16.2933 4.49998L14.5003 2.70698L3.94527 13.262Z"
        fill={color || "#000"}
      />
      <path
        d="M17.5 19H2.5C2.224 19 2 18.776 2 18.5C2 18.224 2.224 18 2.5 18H17.5C17.776 18 18 18.224 18 18.5C18 18.776 17.776 19 17.5 19Z"
        fill={color || "#000"}
      />
    </svg>
  );
});
